import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { mediaQueries, BaseContent } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  padding: 16px 24px;
  border-radius: 2px;

  * {
    color: #fff !important;
  }

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
export const Button = styled.a `
  padding: 8px 18px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 100px;

  &:hover {
    border-color: rgba(255, 255, 255, 1);
  }

  [disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`;
const getButtonProps = (button) => {
    if ('to' in button) {
        return {
            // @ts-ignore
            as: Link,
            to: button.to,
            state: button.state,
        };
    }
    if ('href' in button) {
        return { href: button.href, target: '_blank' };
    }
    return {
        // @ts-ignore
        as: 'button',
        onClick: button.onClick,
    };
};
export const NextStepsBanner = ({ title, description, buttons, color }) => (React.createElement(Container, { style: { background: color } },
    React.createElement("div", null,
        React.createElement(BaseContent, null,
            React.createElement("strong", null, title)),
        React.createElement(BaseContent, { size: "small" }, description)),
    React.createElement("div", { style: { display: 'flex', gap: 16 } }, buttons.map((button) => (React.createElement(Button, { key: button.label, ...getButtonProps(button) }, button.label))))));
